import React from 'react';
import { Check, Shield } from 'lucide-react';
import { handleCheckoutMegapack, handleCheckoutUpsell } from '../utils/checkout';
export function OfferStack() {
  return <section id="pricing" className="bg-black py-16 md:py-24" data-id="element-155">
      <div className="max-w-5xl mx-auto px-4" data-id="element-156">
        <h2 className="text-white text-2xl md:text-4xl font-bold text-center mb-12 font-playfair" data-id="element-157">
          CHOOSE YOUR MEGAPACK
        </h2>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-158">
          {/* Upsell Pack — FIRST (Most Popular) */}
          <div className="bg-nero-card border-2 border-[#D4AF37] rounded-xl p-7 flex flex-col relative shadow-[0_0_20px_rgba(212,175,55,0.3)]" data-id="element-159">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#D4AF37] text-black px-4 py-1 rounded-full text-xs font-bold tracking-wider" data-id="element-160">
              ⭐ MOST POPULAR
            </div>

            <div className="mb-6 mt-2" data-id="element-161">
              <h3 className="text-white text-xl font-bold mb-2" data-id="element-162">
                MegaPack + Client Acquisition Engine
              </h3>
              <p className="text-secondary-text text-sm" data-id="element-163">
                Everything in MegaPack PLUS the How to build a Flow of Leads Kit
              </p>
            </div>

            <div className="mb-6" data-id="element-164">
              <span className="text-gray-500 line-through text-lg block" data-id="element-165">
                NZD $97.00
              </span>
              <div className="flex items-baseline gap-2" data-id="element-166">
                <span className="text-soft-gold text-4xl font-bold" data-id="element-167">
                  NZD $34.99
                </span>
              </div>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-168">
              {['Everything in Professional MegaPack', '100+ Viral Hook Templates', '90-Day Content Matrix', 'Canva Template Library'].map((feature, idx) => <li key={idx} className="flex items-center gap-3 text-white/90 text-sm" data-id="element-169">
                  <Check className="w-4 h-4 text-soft-gold shrink-0" data-id="element-170" />
                  {feature}
                </li>)}
            </ul>

            <button onClick={handleCheckoutUpsell} className="w-full py-4 bg-soft-gold hover:bg-dark-gold text-black font-bold rounded-xl shadow-cta transition-all transform hover:scale-105" data-id="element-171">
              GET THE COMPLETE BUNDLE
            </button>
          </div>

          {/* Standard Pack — SECOND */}
          <div className="bg-nero-card border border-[#8B6914] rounded-xl p-7 flex flex-col" data-id="element-172">
            <div className="mb-6" data-id="element-173">
              <h3 className="text-white text-xl font-bold mb-2" data-id="element-174">
                Professional MegaPack
              </h3>
              <p className="text-secondary-text text-sm" data-id="element-175">
                The complete 6-volume business system
              </p>
            </div>

            <div className="mb-6" data-id="element-176">
              <span className="text-gray-500 line-through text-lg block" data-id="element-177">
                NZD $67.00
              </span>
              <div className="flex items-baseline gap-2" data-id="element-178">
                <span className="text-soft-gold text-4xl font-bold" data-id="element-179">
                  NZD $24.49
                </span>
              </div>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-180">
              {['All 6 Core Volumes', '6 Strategic Bonuses', 'Lifetime Updates', 'Instant Access'].map((feature, idx) => <li key={idx} className="flex items-center gap-3 text-white/90 text-sm" data-id="element-181">
                  <Check className="w-4 h-4 text-soft-gold shrink-0" data-id="element-182" />
                  {feature}
                </li>)}
            </ul>

            <button onClick={handleCheckoutMegapack} className="w-full py-4 bg-soft-gold hover:bg-dark-gold text-black font-bold rounded-xl shadow-cta transition-all" data-id="element-183">
              GET MEGAPACK ONLY
            </button>
          </div>
        </div>

        <div className="mt-12 flex justify-center items-center gap-6 text-secondary-text text-sm" data-id="element-184">
          <div className="flex items-center gap-2" data-id="element-185">
            <Shield className="w-4 h-4" data-id="element-186" />
            <span data-id="element-187">256-bit Secure Checkout</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-188">
            <span data-id="element-189">Powered by Shopify</span>
          </div>
        </div>
      </div>
    </section>;
}